export const SAGE_STATE_ID = 'SAGE_STATE_ID';
